import { FooterNote, LandingScreen } from "../components/Shell";

export default function RootPage() {
  return (
    <>
      <LandingScreen />
      <FooterNote />
    </>
  );
}
